import {
  getEffectiveFactionMemberStatus,
  normalizeLineupSnapshot,
} from './factionLineupRole';

const compareByName = (left, right) =>
  (left?.name || '').localeCompare(right?.name || '', 'it', {
    sensitivity: 'base',
  });

const dedupeIds = (ids = []) => [...new Set(ids.filter(Boolean))];

const mapIdsToMembers = (ids = [], membersById = new Map()) =>
  ids
    .map((id) => membersById.get(id) || null)
    .filter(Boolean);

const normalizeMembers = (faction, members = []) =>
  members
    .filter(Boolean)
    .map((member) => ({
      ...member,
      effectiveStatus: getEffectiveFactionMemberStatus({
        faction,
        wrestlerId: member.id,
        fallbackStatus: member.status || null,
      }),
    }));

export const buildFactionShareCardData = ({ faction, members = [], roster = null }) => {
  const normalizedMembers = normalizeMembers(faction, members);
  const membersById = new Map(
    normalizedMembers.filter((member) => member?.id).map((member) => [member.id, member])
  );

  const storedLineup =
    normalizeLineupSnapshot(faction?.currentLineup) ||
    normalizeLineupSnapshot(faction?.lineup);

  const fallbackChampionId =
    normalizedMembers.find((member) => member.effectiveStatus === 'Main_Eventer')?.id || null;

  const fallbackInRingIds = normalizedMembers
    .filter((member) =>
      member.effectiveStatus === 'Main_Eventer' || member.effectiveStatus === 'In_Ring'
    )
    .map((member) => member.id);

  const fallbackBackstageIds = normalizedMembers
    .filter((member) => member.effectiveStatus === 'Backstage')
    .map((member) => member.id);

  const championId = storedLineup?.champion || fallbackChampionId;
  const inRingIds = dedupeIds(storedLineup?.inRing?.length ? storedLineup.inRing : fallbackInRingIds);
  const backstageIds = dedupeIds(
    storedLineup?.backstage?.length ? storedLineup.backstage : fallbackBackstageIds
  );

  const mainEventer = championId ? membersById.get(championId) || null : null;
  const inRingMembers = mapIdsToMembers(
    inRingIds.filter((id) => id !== championId),
    membersById
  );
  const backstageMembers = mapIdsToMembers(
    backstageIds.filter((id) => id !== championId),
    membersById
  );

  const assignedIds = new Set([
    championId,
    ...inRingMembers.map((member) => member.id),
    ...backstageMembers.map((member) => member.id),
  ]);

  const unassignedMembers = normalizedMembers
    .filter((member) => !assignedIds.has(member.id))
    .sort(compareByName);

  const hasLineup =
    Boolean(storedLineup) ||
    Boolean(mainEventer) ||
    inRingMembers.length > 0 ||
    backstageMembers.length > 0;

  return {
    title: faction?.name || 'La mia fazione',
    rosterName: roster?.name || faction?.rosterName || faction?.roster || '',
    gameType: roster?.gameType || faction?.gameType || '',
    hasLineup,
    mainEventer,
    inRingMembers,
    backstageMembers,
    unassignedMembers,
    allMembers: [...normalizedMembers].sort(compareByName),
  };
};

export const getFactionShareText = (factionName = '') =>
  factionName
    ? `Guarda la mia fazione "${factionName}" su FantaWrestling`
    : 'Guarda la mia fazione su FantaWrestling';
